import { useState, useEffect } from "react";
import { useServices } from "@/hooks/useServices";

export interface CompanyInfo {
  name: string;
  address: string;
  oib: string;
  mbs: string;
  email: string;
  phone: string;
  dpoEmail: string;
}

const KEYS = [
  "invoice_company_name",
  "invoice_company_address",
  "invoice_oib",
  "invoice_mbs",
  "invoice_email",
  "invoice_phone",
  "invoice_dpo_email",
] as const;

export function useCompanyInfo(): CompanyInfo {
  const { settingsService } = useServices();
  const [info, setInfo] = useState<CompanyInfo>({
    name: "Thenea",
    address: "",
    oib: "",
    mbs: "",
    email: "",
    phone: "",
    dpoEmail: "",
  });

  useEffect(() => {
    settingsService.getSettings([...KEYS]).then((m) => {
        setInfo({
          name: m.invoice_company_name || "Thenea",
          address: m.invoice_company_address || "",
          oib: m.invoice_oib || "",
          mbs: m.invoice_mbs || "",
          email: m.invoice_email || "",
          phone: m.invoice_phone || "",
          dpoEmail: m.invoice_dpo_email || "",
        });
      });
  }, [settingsService]);

  return info;
}
